import ReducerUtilities from '../../../shared/store/reducer-utilities';
import departmentSettingsModel from '../../models/department-settings';
import notificationModel from '../../models/notification';
import departmentSettingsCommitTypes from './commit-types';

const INITIAL_DEPARTMENT_SETTINGS_STATE = {
  isEditingNotification: false,
  isLoading: [],
  notifications: null,
  selectedNotificationGuid: null,
  settings: null,
  tasks: null,
  isAddingTask: false,
};

function departmentSettingsReducers(state = INITIAL_DEPARTMENT_SETTINGS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case departmentSettingsCommitTypes.PUSH_NOTIFICATIONS:
      return {
        ...state,
        notifications: [...action.notifications.map(item => notificationModel(item))],
      };
    case departmentSettingsCommitTypes.REPLACE_NOTIFICATION:
      return {
        ...state,
        notifications: ReducerUtilities.replaceModelInList(notificationModel(action.notification), state.notifications),
      };
    case departmentSettingsCommitTypes.RESET_DEPARTMENT_SETTINGS_STATE:
      return { ...INITIAL_DEPARTMENT_SETTINGS_STATE };
    case departmentSettingsCommitTypes.SET_DEPARTMENT_SETTINGS:
      return {
        ...state,
        settings: departmentSettingsModel(action.settings),
      };
    case departmentSettingsCommitTypes.SET_DEPARTMENT_SETTINGS_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(action.isLoading, state.isLoading),
      };
    case departmentSettingsCommitTypes.SET_IS_EDITING_NOTIFICATION:
      return {
        ...state,
        isEditingNotification: action.isEditingNotification,
      };
    case departmentSettingsCommitTypes.SET_SELECTED_NOTIFICATION:
      return {
        ...state,
        selectedNotificationGuid: action.selectedNotificationGuid,
      };
    default:
      return state;
  }
}

export default departmentSettingsReducers;
